// Sem new Vue no #app_home: a home não usa nada do Vue e, ao montar, ele
// recriava todo o DOM do #app_home — o <video> do banner recarregava e piscava
waitForElementToExist('#faixa-cupom').then(element => {
    const cupomButton = document.getElementById("valorParaCopiar");
    if (cupomButton) {
        var cupomValue = cupomButton.getAttribute('data-cupom').replace(/^\/\//, '');
        cupomButton.textContent = cupomValue;

        cupomButton.addEventListener("click", (e) => {
            e.preventDefault();

            if (navigator.clipboard) {
                navigator.clipboard.writeText(cupomValue).then(() => {
                    alert("Valor copiado: " + cupomValue);
                });
            } else {
                var tempInput = document.createElement("input");
                tempInput.value = cupomValue;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand("copy");
                document.body.removeChild(tempInput);
                alert("Valor copiado: " + cupomValue);
            }
        });
    }
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if (bannerHome) {
        const mediaSelector = '.home__banner--figure img, video, iframe.vimeo, .header';

        const currentMedia = function () {
            const slide = bannerHome.querySelector('.slick-current') || bannerHome;
            return slide.classList.contains('header') ? slide : slide.querySelector(mediaSelector);
        };

        let lastHeight = 0;

        const syncBannerHeight = function () {
            const media = currentMedia();
            if (!media) {
                return;
            }

            const mediaHeight = Math.round(media.getBoundingClientRect().height);
            if (mediaHeight && mediaHeight !== lastHeight) {
                lastHeight = mediaHeight;
                bannerHome.style.height = mediaHeight + 'px';

                // O adaptiveHeight do slick mede o slide só no init; se o vídeo
                // ainda não tinha metadata, o .slick-list fica com os 150px
                // padrão de <video> e corta o banner até o window.load
                if (bannerHomeFull.hasClass('slick-initialized')) {
                    bannerHomeFull.slick('setPosition');
                }
            }
        };

        syncBannerHeight();

        bannerHomeFull.on('afterChange', syncBannerHeight);
        window.addEventListener('resize', syncBannerHeight);

        bannerHome.querySelectorAll(mediaSelector).forEach(function (media) {
            media.addEventListener('load', syncBannerHeight);
            media.addEventListener('loadedmetadata', syncBannerHeight);

            if (window.ResizeObserver) {
                new ResizeObserver(syncBannerHeight).observe(media);
            }
        });
    }

    waitForElementToExist('.logo-scroll').then(logoScroll => {
        waitForElementToExist('.first-vitrine').then(firstVitrine => {
            let ticking = false;

            function toggleLogoScroll() {
                const vitrineTop = firstVitrine.getBoundingClientRect().top;
                const logoTop = logoScroll.getBoundingClientRect().top;
                logoScroll.classList.toggle('logo-scroll--hidden', vitrineTop <= logoTop);
                ticking = false;
            }

            toggleLogoScroll();

            window.addEventListener('scroll', () => {
                if (!ticking) {
                    window.requestAnimationFrame(toggleLogoScroll);
                    ticking = true;
                }
            }, { passive: true });
        });
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        $('.faixa-comunicado-content').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.banner-product').then(element => {
        $('#product-banner').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                    }
                }
            ]
        });

        // Prevenir redirecionamento ao clicar nas arrows do slick
        $('.banner-product').on('click', '.slick-arrow, .slick-prev, .slick-next', function(e) {
            e.preventDefault();
            e.stopPropagation();
        });

        $('#product-banner').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if (firstCarrousel) {
            $('#product_list').slick({
                swipeToSlide: true,
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".group-arrow .group-arrow-prev"),
                nextArrow: $(".group-arrow .group-arrow-next"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

     waitForElementToExist('.five-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list5');
        if (firstCarrousel) {
            $('#product_list5').slick({
                swipeToSlide: true,
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".group-arrow .group-arrow-prev5"),
                nextArrow: $(".group-arrow .group-arrow-next5"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list5').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        $('#product_list2').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            prevArrow: $(".group-arrow .group-arrow-prev2"),
            nextArrow: $(".group-arrow .group-arrow-next2"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".count .count-prev"),
            nextArrow: $(".count .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".count .count-prev2"),
            nextArrow: $(".count .count-next2"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list3').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".count .count-prev3"),
            nextArrow: $(".count .count-next3"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list4').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".count .count-prev4"),
            nextArrow: $(".count .count-next4"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list5').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".count .count-prev5"),
            nextArrow: $(".count .count-next5"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list6').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            prevArrow: $(".count .count-prev6"),
            nextArrow: $(".count .count-next6"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                        '#carrousel-product-list3',
                        '#carrousel-product-list4',
                        '#carrousel-product-list5',
                        '#carrousel-product-list6',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5, #carrousel-product-list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.blog-content').then(element => {
        $('.blog-content').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                },
            ]
        });
    });

    waitForElementToExist('#categories-home-carrousel').then(element => {
        $('#categories-home-carrousel').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            infinite: false,
            autoplay: false,
            dots: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.product-detail-faq').then(element => {
        const productDetailFaqListItems = document.querySelectorAll('.product-detail-faq-list-item');

        if (productDetailFaqListItems.length) {
            productDetailFaqListItems[0].classList.add('active');

            function activeTab(index) {
                productDetailFaqListItems.forEach((content) => {
                    content.classList.remove('active');
                });
                productDetailFaqListItems[index].classList.add('active');
            }

            productDetailFaqListItems.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => {
                    activeTab(index);
                });
            });
        }
    });

});